// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  Speedometer,
  Add,
  Link1,
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  BookSquare,
  Mobile,
  Crown,
  UserEdit,
  UserSearch,
  Warning2,
  ChartSquare, FolderCloud

} from 'iconsax-react';
import { isAdmin } from 'lib';

// type

// icons
const icons = {
  marketing: Mobile,
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  add: Add,
  link: Link1,
  Quick: Speedometer,
  report: BookSquare,
  dynamicReport: ChartSquare,
  fileHub: FolderCloud
};

const adminItem = (id, url) => ({
  id,
  title: <FormattedMessage id={id} defaultMessage={id} />,
  type: 'item',
  url,
  breadcrumbs: false
});

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //
export const getPages = (permissions) => {
  const isDevelopment = true;//process.env.NODE_ENV === 'development';
  const isShowDynamicReport = process.env.NODE_ENV === 'development';
  const pages = {
    id: 'group-applications',
    type: 'group',
    className: 'dropdown',
    children: [
      {
        id: 'dashboards',
        title: <FormattedMessage id="Dashboards" defaultMessage={"Dashboards"} />,
        type: 'collapse',
        icon: icons.dynamicReport,
        className: 'dropdown-item',
        children: [
          {
            id: 'CareManagerDashboard',
            title: <FormattedMessage id="Care Manager Dashboard" defaultMessage={"Care Manager"} />,
            type: 'item',
            url: '/care-manager-dashboard',
            breadcrumbs: false
          },
          {
            id: 'ApplicantsDashboard',
            title: <FormattedMessage id="Applicants Dashboard" defaultMessage={"Applicants"} />,
            type: 'item',
            url: '/applicants/dashboard',
            breadcrumbs: false
          },
          {
            id: 'MarketingDashboard',
            title: <FormattedMessage id="Marketing Dashboard" defaultMessage={"Marketing"} />,
            type: 'item',
            url: '/marketing/dashboard',
            breadcrumbs: false
          }
        ]
      },
      {
        id: 'quick-hits',
        title: <FormattedMessage id="Quick Hits" defaultMessage={"Quick Hits"} />,
        type: 'collapse',
        icon: icons.Quick,
        className: 'dropdown-item',
        url: '/quick-hits',
        breadcrumbs: false,
        children: [
          {
            id: 'Current Notes',
            title: <FormattedMessage id="Current Notes" defaultMessage={"Current Notes"} />,
            type: 'item',
            url: '/quick-hits?id=notes',
            breadcrumbs: false
          },
          {
            id: 'Sensitive Issue',
            title: <FormattedMessage id="Sensitive Issue" defaultMessage={"Sensitive Issue"} />,
            type: 'item',
            url: '/quick-hits?id=issue',
            breadcrumbs: false
          },
          {
            id: 'Action Required',
            title: <FormattedMessage id="Action Required" defaultMessage={"Action Required"} />,
            type: 'item',
            url: '/quick-hits?id=action',
            breadcrumbs: false
          },
          {
            id: 'Health Check',
            title: <FormattedMessage id="Health Check" defaultMessage={"Health Check"} />,
            type: 'item',
            url: '/quick-hits?id=health',
            breadcrumbs: false
          },
          {
            id: 'Keep In View',
            title: <FormattedMessage id="Keep In View" defaultMessage={"Keep In View"} />,
            type: 'item',
            url: '/quick-hits?id=view',
            breadcrumbs: false
          },
          {
            id: 'Care Manager',
            title: <FormattedMessage id="Care Manager" defaultMessage={"Care Manager"} />,
            type: 'item',
            url: '/quick-hits?id=care',
            breadcrumbs: false
          }
        ]
      },
      {
        id: 'care-planning',
        title: <FormattedMessage id="Care Planning" defaultMessage={"Care Planning"} />,
        type: 'collapse',
        icon: icons.profile,
        className: 'dropdown-item',
        children: [
          {
            id: 'Clients',
            title: <FormattedMessage id="Clients" defaultMessage={"Clients"} />,
            type: 'item',
            url: '/client',
            breadcrumbs: false
          },
          {
            id: 'Care Partners',
            title: <FormattedMessage id="Care Partners" defaultMessage={"Care Partners"} />,
            type: 'item',
            url: '/care-partner',
            breadcrumbs: false
          },
          {
            id: 'Care Management',
            title: <FormattedMessage id="Care Management" defaultMessage={"Care Management"} />,
            type: 'item',
            url: '/care-management',
            breadcrumbs: false
          },
          {
            id: 'Award Management',
            title: <FormattedMessage id="Award Management" defaultMessage={"Award Management"} />,
            type: 'item',
            url: '/award-management',
            breadcrumbs: false
          },
          // ...(isShowDynamicReport ?
          // [
          // {
          //   id: 'Care Manager Dashboard',
          //   title: <FormattedMessage id="Care Manager Dashboard" defaultMessage={"Care Manager Dashboard"} />,
          //   type: 'item',
          //   url: '/care-manager-dashboard',
          //   breadcrumbs: false
          // }
          // ]:[])
        ]
      },



      {
        id: 'Recruiting',
        title: <FormattedMessage id="Recruiting" defaultMessage={"Recruiting"} />,
        type: 'collapse',
        icon: icons.ecommerce,
        children: [
          {
            id: 'Applicants',
            title: <FormattedMessage id="Applicants" defaultMessage={"Applicants"} />,
            type: 'item',
            url: '/applicants',
            breadcrumbs: false
          },
          {
            id: 'Activities',
            title: <FormattedMessage id="Activities" defaultMessage={"Activities"} />,
            type: 'item',
            url: '/applicants/activity',
            breadcrumbs: false
          },
          // {
          //   id: 'ApplicantsDashboard',
          //   title: <FormattedMessage id="Applicants Dashboard" defaultMessage={"Applicants Dashboard"} />,
          //   type: 'item',
          //   url: '/applicants/dashboard',
          //   breadcrumbs: false
          // },
          // {
          //   id: 'RecruitingCareManagerDashboard',
          //   title: <FormattedMessage id="Applicants Dashboard" defaultMessage={"Applicants Dashboard"} />,
          //   type: 'item',
          //   url: '/applicants/dashboard',
          //   breadcrumbs: false
          // }
          // {
          //   id: 'Snapshot',
          //   title: <FormattedMessage id="Snapshot" defaultMessage={"Snapshot"} />,
          //   type: 'item',
          //   link: '/apps/e-commerce/product-details/:id',
          //   url: '/snapshot',
          //   breadcrumbs: false
          // },
          // {
          //   id: 'Status',
          //   title: <FormattedMessage id="Status" defaultMessage={"Status"} />,
          //   type: 'item',
          //   url: '/status',
          //   breadcrumbs: false
          // }
        ]
      },

      {
        id: 'Marketing',
        title: <FormattedMessage id="Marketing" defaultMessage={"Marketing"} />,
        type: 'collapse',
        icon: icons.marketing,
        children: [
          {
            id: 'Referral',
            title: <FormattedMessage id="Referral Partners" />,
            type: 'item',
            url: '/referral',
            breadcrumbs: false
          },
          {
            id: 'Prospect',
            title: <FormattedMessage id="Prospects" defaultMessage={"Prospects"} />,
            type: 'item',
            url: '/prospects',
            breadcrumbs: false
          },
          {
            id: 'Activities',
            title: <FormattedMessage id="Activities" defaultMessage={"Activities"} />,
            type: 'item',
            url: '/activity',
            breadcrumbs: false
          }
        ]
      },
      {
        id: 'Authorization',
        title: <FormattedMessage id="Authorization" defaultMessage={"Authorizations"} />,
        type: 'collapse',
        icon: icons.profile,
        className: 'dropdown-item',
        children: [
          {
            id: 'AuthorizationsList',
            title: <FormattedMessage id="Authorizations" defaultMessage={"Authorizations"} />,
            type: 'item',
            url: '/authorization',
            breadcrumbs: false
          },
          {
            id: 'AuthorizationActivities',
            title: <FormattedMessage id="Activities" defaultMessage={"Activities"} />,
            type: 'item',
            url: '/authorization/activity',
            breadcrumbs: false
          }
        ]
      },
      {
        id: 'Reporting',
        title: <FormattedMessage id="Reporting" defaultMessage={"Reporting"} />,
        type: 'collapse',
        icon: icons.report,
        children: [
          {
            id: 'Care Management',
            title: <FormattedMessage id="Care Management" defaultMessage={"Care Management"} />,
            type: 'item',
            url: '/reporting/care-management',
            breadcrumbs: false
          },
          {
            id: 'Applicants',
            title: <FormattedMessage id="Applicants" defaultMessage={"Applicants"} />,
            type: 'item',
            url: '/reporting/applicants',
            breadcrumbs: false
          },
          {
            id: 'Prospects',
            title: <FormattedMessage id="Prospects" defaultMessage={"Prospects"} />,
            type: 'item',
            url: '/reporting/prospects',
            breadcrumbs: false
          },
          {
            id: 'Referral Partners',
            title: <FormattedMessage id="Referral Partners" defaultMessage={"Referral Partners"} />,
            type: 'item',
            url: '/reporting/referral-partner',
            breadcrumbs: false
          }
        ]
      },
      ...(isDevelopment
        ? [
          {
            id: 'File Hub',
            title: (
              <FormattedMessage id="File Hub" defaultMessage={'File Hub'} />
            ),
            type: 'collapse',
            icon: icons.fileHub,
            url: '/file-hub',
            breadcrumbs: false,
          },
        ]
        : []),
      // ...(isShowDynamicReport
      //   ? [
      //     {
      //       id: 'Report Builder',
      //       title: (
      //         <FormattedMessage id="Report Builder" defaultMessage={'Report Builder'} />
      //       ),
      //       type: 'collapse',
      //       icon: icons.dynamicReport,
      //       url: '/report-builder',
      //       breadcrumbs: false,
      //     },
      //   ]
      //   : []),
      ...(isAdmin(permissions)
        ? [
          {
            id: 'Advanced Report Builder',
            title: (
              <FormattedMessage id="Report Builder" defaultMessage={'Report Builder'} />
            ),
            type: 'collapse',
            icon: icons.dynamicReport,
            url: '/advanced-report-builder',
            breadcrumbs: false,
          },
        ]
        : []),
      // {
      //   id: 'File Hub',
      //   title: <FormattedMessage id="File Hub" defaultMessage={"File Hub"} />,
      //   type: 'collapse',
      //   icon: icons.report,
      //   url: '/file-hub',
      //   breadcrumbs: false
      // },
      ...(isAdmin(permissions)
        ? [{
          id: 'Admin',
          title: <FormattedMessage id="Admin" />,
          type: 'collapse',
          // icon: Profile2User,
          icon: UserSearch,
          children: [
            {
              id: 'Global Settings',
              title: <FormattedMessage id="Global Settings" defaultMessage="Global Settings" />,
              type: 'collapse',
              icon: UserSearch,
              children: [
                adminItem('User Management', '/user-management'),
                adminItem('Location Management', '/location-management'),
                adminItem('Vendor Management', '/vendor-management'),
                adminItem('Award Type Management', '/award-type-management'),
                adminItem('File Uploader Sections', '/file-hub-sections'),
                adminItem('Authorization Types', '/authorization-types'),
                adminItem('Stage Management', '/stage-management'),
                adminItem('Stage Options', '/stage-options'),
                adminItem('Contact Types', '/contact-types'),
                adminItem('Contact Relationships', '/contact-relationships'),
                adminItem('Activity Management', '/activity-management'),
                adminItem('Activity Category Management', '/activity-category-management'),
                adminItem('Tags', '/tags'),
                adminItem('Tag Category', '/tag-category'),
                adminItem('Merge Records', '/merge-records')
              ]
            },
            {
              id: 'Prospect Settings',
              title: <FormattedMessage id="Prospect Settings" defaultMessage="Prospect Settings" />,
              type: 'collapse',
              icon: Mobile,
              children: [
                adminItem('Prospect Activity', '/prospect-activity'),
                adminItem('Prospect Activity Category', '/prospect-activity-category'),
                adminItem('Lead Source', '/lead-source')
              ]
            },
            {
              id: 'Referral Partner Settings',
              title: <FormattedMessage id="Referral Partner Settings" defaultMessage="Referral Partner Settings" />,
              type: 'collapse',
              icon: Link1,
              children: [
                adminItem('Referral Partners Type', '/referral-partners-type'),
                adminItem('Referral Partners Activity', '/referral-partners-activity'),
                adminItem('Referral Partners Activity Category', '/referral-partners-activity-category'),
                adminItem('Rating Referral', '/rating-referral'),
                adminItem('Rating Referral Company', '/rating-referral-company')
              ]
            },
            {
              id: 'Applicant Settings',
              title: <FormattedMessage id="Applicant Settings" defaultMessage="Applicant Settings" />,
              type: 'collapse',
              icon: Profile2User,
              children: [
                adminItem('Applicant Source', '/applicant-source'),
                adminItem('Applicant Stage Options', '/applicant-stage'),
                adminItem('Applicant Activity Type', '/applicant-activity-type'),
                adminItem('Applicant Activity Type Category', '/applicant-activity-type-category')
              ]
            },
            {
              id: 'Client & Care Partner',
              title: <FormattedMessage id="Client & Care Partner" defaultMessage="Client & Care Partner" />,
              type: 'collapse',
              icon: UserSquare,
              children: [
                adminItem('Lost Client Options', '/lost-client-options'),
                adminItem('Client Deactivation Reasons', '/client-deactivation'),
                adminItem('Care Partner Deactivation Reasons', '/care-partner-deactivation')
              ]
            },
            {
              id: 'Priority Settings',
              title: <FormattedMessage id="Priority Settings" defaultMessage="Priority Settings" />,
              type: 'collapse',
              icon: ChartSquare,
              children: [
                adminItem('Priority Rating', '/priority-index'),
                adminItem('Priority Rating Care Partner', '/priority-index-cp')
              ]
            },
            {
              id: 'Disciplinary',
              title: <FormattedMessage id="Disciplinary" />,
              type: 'collapse',
              icon: Warning2,
              children: [
                {
                  id: 'Disciplinary Step',
                  title: <FormattedMessage id="Disciplinary Step" />,
                  type: 'item',
                  url: '/disciplinary-step',
                  breadcrumbs: false
                },
                {
                  id: 'Disciplinary Category',
                  title: <FormattedMessage id="Disciplinary Category" />,
                  type: 'item',
                  url: '/disciplinary-category',
                  breadcrumbs: false
                },
                {
                  id: 'Disciplinary CP Acknowledgment',
                  title: <FormattedMessage id="Disciplinary CP Acknowledgment" />,
                  type: 'item',
                  url: '/disciplinary-ack',
                  breadcrumbs: false
                },
                {
                  id: 'Disciplinary Attendance Type',
                  title: <FormattedMessage id="Disciplinary Attendance Type" />,
                  type: 'item',
                  url: '/disciplinary-attendance-type',
                  breadcrumbs: false
                },
                adminItem('Disciplinary Threshold', '/applicant-threshold')
              ]
            }
          ]
        }] : [])
    ]
  };
  return pages;
}
//export default pages;
